export default "__VITE_ASSET__qG0q1duK__"